import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "typeFile",
})
export class TypeFilePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let icon: string;
    console.info("icono");
    console.log(value);

    switch (value) {
      case 5:
        icon = "fa fa-file-video";
        break;

      case 6:
        icon = "fa fa-file-audio";
        break;
      case 7:
        icon = "fa fa-file-pdf";
        break;

      case 11:
        icon = "fa fa-file-pdf";
        break;
      case 16:
        icon = "fas fa-book";
        break;
      case 8:
        icon = "fa fa-cube";
        break;

      case 9:
        icon = "fas fa-book-reader";
        break;
      case 21:
        icon = "fas fa-book-reader";
        break;
      case 20:
        icon = "fa fa-file-powerpoint";
        break;
      case 9999:
        icon = "fa fa-play-circle";
        break;
      default:
        icon = "fa fa-file";
        break;
    }
    return icon;
  }
}
